// eslint-disable-next-line import/prefer-default-export
export enum PersonalOutcomeType {
  Entrepreneurial = "entrepreneurial",
  Innovative = "innovative",
  Inspirational = "inspirational",
  Resilient = "resilient",
  Growth = "growth",
  Collaborative = "collaborative",
  Productive = "productive",
  Strategic = "strategic",
  Compassionate = "compassionate",
}
